import React, { useState, useEffect } from "react";
import "../account-details/account-details.scss";
import AddressImg from "../../assets/accounts/address.svg";
import InfoImg from "../../assets/accounts/info.svg";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion";
import PageHeader from "../../components/table/pageHeader/PageHeader";
import useContact from "../../controller/contact-controller";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import ContactSvgHeader from "../../assets/sidebar/dealerPortal/ContactSvgHeader";

const ContactsDetails = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { getContactDetails, contactDetail, isLoading, errMsg } = useContact();
  const [isLoader, setIsLoader] = useState(false);
  const [contactInfo, setContactInfo] = useState({});
  const [openAcc, setOpenAcc] = useState(["0", "1"]);

  useEffect(() => {
    getContactDetails(params?.cid);
  }, []);

  useEffect(() => {
    setContactInfo(contactDetail);
  }, [contactDetail]);

  useEffect(() => {
    setIsLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (errMsg) {
      toast.error(errMsg);
    }
  }, [errMsg]);

  return (
    <div
      className={`accounts-container h-full flex flex-col mt-2 md:static overflow-y-auto relative ${
        isLoader ? "-mt-[70px]" : ""
      }`}
    >
      {isLoader ? (
        <div className="flex h-full justify-center align-center">
          <Loader />
        </div>
      ) : (
        <>
          <PageHeader
            isBackBtn={true}
            onBackClick={() => navigate("/contacts")}
            svg={<ContactSvgHeader color={"white"} />}
            text="Contact"
            subTitle={contactInfo?.contactName}
          />
          <div className="accordianWrapper">
            <Accordion
              allowMultipleExpanded={true}
              allowZeroExpanded={true}
              preExpanded={["0", "1"]}
              onChange={(item) => setOpenAcc(item)}
            >
              <AccordionItem uuid={"0"} className="accItem mb-4">
                <AccordionItemHeading>
                  <AccordionItemButton
                    className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                      openAcc.includes("0")
                        ? "md:rounded-t-lg"
                        : "md:rounded-lg"
                    }`}
                  >
                    <div className=" flex flex-row font-semibold md:text-[22px] text-base accTitle">
                      <img src={InfoImg} alt="infoImg" className="mr-2" />
                      Basic Information
                    </div>
                    <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <div className="accIconOpen inline-block mr-3" />
                        ) : (
                          <div className="accIconClose inline-block mr-3 rotate-45" />
                        )
                      }
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                    <div className="grid md:grid-cols-2  md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Name
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {contactInfo?.contactName}
                        </div>
                      </div>
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Contact Owner
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {contactInfo?.ownerName}
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2  md:mb-4">
                      <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Account Name
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                          {contactInfo?.accountName}
                        </div>
                      </div>
                      <div className="grid">
                        <div className="grid grid-cols-2 fieldWrapper md:pb-2 pb-2 md:mb-0 mb-4 pl-0 px-3">
                          <div className="fieldName font-normal md:text-lg text-base">
                            Phone
                          </div>
                          <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end">
                            {contactInfo?.Phone}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="grid md:grid-cols-2">
                      <div className="grid grid-cols-2 h-fit fieldWrapper md:pb-2 pb-2 pl-0 px-3 md:mr-10">
                        <div className="fieldName font-normal md:text-lg text-base">
                          Email
                        </div>
                        <div className="fieldDetails font-medium md:text-base text-sm md:text-left text-end text-primary">
                          <div className="flex  flex-row items-center md:justify-start justify-end">
                            {contactInfo?.email}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>

              {contactInfo?.street ||
              contactInfo?.city ||
              contactInfo?.postalCode ||
              contactInfo?.state ||
              contactInfo?.country ? (
                <AccordionItem uuid={"1"} className="accItem mb-4">
                  <AccordionItemHeading>
                    <AccordionItemButton
                      className={`bg-white-200 accButton py-4 px-4 flex flex-row justify-between items-center ${
                        openAcc.includes("1")
                          ? "md:rounded-t-lg"
                          : "md:rounded-lg"
                      }`}
                    >
                      <div className="flex flex-row font-semibold md:text-[22px] text-base accTitle">
                        <img src={AddressImg} alt="infoImg" className="mr-2" />
                        Address Information
                      </div>
                      <AccordionItemState>
                        {({ expanded }) =>
                          expanded ? (
                            <div className="accIconOpen inline-block mr-3" />
                          ) : (
                            <div className="accIconClose inline-block mr-3 rotate-45" />
                          )
                        }
                      </AccordionItemState>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="bg-white-100 accPanel grid md:rounded-b-lg py-5 px-4">
                      <div className="grid md:grid-cols-2">
                        <div className="grid md:grid-cols-2 md:mb-0 md:mr-10">
                          <div className="">
                            <div className="fieldName font-normal md:text-lg text-base mb-2">
                              Mailing Address
                            </div>
                            <div className="fieldDetails font-medium md:text-base text-sm">
                              <div className="flex flex-row rounded-lg p-4 addressData">
                                {contactInfo?.street},<br />
                                {contactInfo?.city}, {contactInfo?.postalCode}
                                ,
                                <br />
                                {contactInfo?.state},<br />
                                {contactInfo?.country}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>
              ) : null}
            </Accordion>
          </div>
        </>
      )}
    </div>
  );
};

export default ContactsDetails;
